export default "__VITE_ASSET__B40dR5zi__"